import moment from 'moment';

/**
 * Scroll to the month and set focus. This will also remove the loader.
 * @param month
 * @param viewMode
 */
export function scrollToMonth(month: moment.Moment): boolean {
    const mmtId = getMonthElementFromMoment(month);

    const destinationMonth = getMonthElement(month);
    if (destinationMonth) {
        if (destinationMonth.id.indexOf("Month-List-") > -1) {
            window.location.hash = `Month-List-${mmtId}`;
        } else {
            window.location.hash = `Month-${mmtId}`;
        }

        removeLoader();

        return true;
    }

    return false;
}

function getMonthElementFromMoment(month: moment.Moment): string {
    return month.startOf("month").format("X");
}

export function getMonthElement(month: moment.Moment): HTMLElement {
    const key = getMonthElementFromMoment(month);
    return document.getElementById(`Month-${key}`) || document.getElementById(`Month-List-${key}`);
}

/**
 * Call this function to remove the loader. Note this isn't tied into redux or anything because of the scroll-to-month requiring
 * the month to load first and the hash set before disappearing.
 */
export function removeLoader() {
    // attribute is added in the calendar-container component when loading state is triggered
    document.documentElement.removeAttribute("data-calendar-loading");
}